import React, { useContext } from 'react';
import styled from 'styled-components';
import iconNewTopic from '../images/fa-redo-green.svg';
import { ConversationContext } from '../contexts/ConversationContext';

const ConversationResetDiv = styled.div<{disabled: boolean}>`
    text-align: right;
    padding-bottom: 15px;
    padding-right: 20px;
    color: #008334;
    @media (max-width: 768px) {
        padding-right: 0; padding-bottom: 10px;
    }
    a {
        font-size: 15px; text-decoration: none;
        img {width: 18px; padding-left: 10px; margin-bottom: 0;}
        &:hover {
            text-decoration: underline;
            img {width: 20px; padding-left: 8px; margin-top: -2px;}
        }
    }
`

export const ConversationReset: React.FC = () => {
    const { conversationState, messages, resetConversation } = useContext(ConversationContext);

    /* TODO Styling: 
        - handling des disabled state 
        - für mein Auge ist Icon und Text nicht sauber ausgerichtet
    */

    if (!messages || messages.length === 0) return null;
    return (
        <ConversationResetDiv disabled={conversationState !== 'idle'}>
            <a href="/" onClick={e => { resetConversation(); e.preventDefault(); }} title="Neue Konversation starten">Neue Konversation starten:<img src={iconNewTopic} alt="Neue Konversation starten" /></a>
        </ConversationResetDiv>
    )
}